import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n'
import './assets/font.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faTwitter, faFacebook, faInstagram, faLinkedin, faYoutube, faGithub, faTelegram, faWeixin } from '@fortawesome/free-brands-svg-icons'
import { faGlobe } from '@fortawesome/free-solid-svg-icons'

library.add(faTwitter, faFacebook, faInstagram, faLinkedin, faYoutube, faGithub, faTelegram, faWeixin, faGlobe)

Vue.component('font-awesome-icon', FontAwesomeIcon)

// 屏幕适配
import '@/utils/rem.js'

//引入elementui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//时间过滤器
Vue.filter('formatDate', (date, time) => {
  const nDate = new Date(date * 1000)
  const year = nDate.getFullYear()
  const month = (nDate.getMonth() + 1).toString().padStart(2, 0)
  const day = nDate.getDate().toString().padStart(2, 0)
  const hour = nDate.getHours().toString().padStart(2, 0)
  const minute = nDate.getMinutes().toString().padStart(2, 0)
  const second = nDate.getSeconds().toString().padStart(2, 0)
  if (time && time.toLowerCase() === 'yyyy-mm-dd') {
    return `${year}-${month}-${day}`
  } else if (time && time.toLowerCase() === 'hh:mm:ss') {
    return `${hour}:${minute}:${second}`
  } else {
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`
  }
})
//Axios
import axios from 'axios'
axios.defaults.baseURL = 'https://web.vrc20.cn'

// Add response interceptor for error handling
axios.interceptors.response.use(
  response => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    return response
  },
  error => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let errorMessage = 'An error occurred'
    
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      switch (error.response.status) {
        case 400:
          errorMessage = 'Bad request'
          break
        case 401:
          errorMessage = 'Unauthorized access'
          break
        case 403:
          errorMessage = 'Forbidden'
          break
        case 404:
          errorMessage = 'Resource not found'
          break
        case 500:
          errorMessage = 'Internal server error'
          break
        case 502:
          errorMessage = 'Bad gateway'
          break
        case 503:
          errorMessage = 'Service unavailable'
          break
        default:
          errorMessage = `Error: ${error.response.status}`
      }
      
      // Add custom message if available from backend
      if (error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message
      }
    } else if (error.request) {
      // The request was made but no response was received
      errorMessage = 'No response from server. Please check your connection.'
    } else {
      // Something happened in setting up the request that triggered an Error
      errorMessage = error.message || 'Request failed'
    }
    
    // Show error toast using ElementUI
    ElementUI.Message.error({
      message: errorMessage,
      duration: 3000,
      showClose: true
    })
    
    // Return a rejected promise so individual handlers can still catch if needed
    return Promise.reject(error)
  }
)

Vue.prototype.$axios = axios

Vue.use(ElementUI)
Vue.prototype.$bus = new Vue()

Vue.config.productionTip = false

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'en-US',
  messages: {
    'en-US': {
      nav: {
        TCPrice: 'TC Price',
        dollar: 'Dollar',
        totop: 'To Top',
        Copyright: 'Copyright',
      },
      index: {
        blockchainexplorer: 'VoidChain blockchain explorer',
        AllFilters: 'All Filters',
        address: 'Address',
        transaction: 'Hash',
        block: 'Block',
        desc: 'VoidChain Trusted Node Blockchain - The main network node operates in a completely decentralized and closed secure space without human interference',
        Dynamicsharding: 'Dynamic meta space',
        TotalBlock: 'Total Block',
        Tradingvolume: 'Trading volume',
        Numberofaddresses: 'Number of addresses',
        Staticsharding: 'Static meta space',
        Activeaddress: 'Active address',
        Totalnumberofnodes: 'Total number of nodes',
        Addnewnodes: 'Add new nodes',
        oneNum: 'One layer quantity (computational power)',
        twoNum: 'Two layer quantity (computational power)',
        threeNum: 'Three layer quantity (computational power)',
        fourNum: 'Four layer quantity (computational power)',
        Tokentotal: 'Token total',
        latestdata: 'Latest data',
        consensus: 'Consensus algorithm',
        Processingquantitypersecond: 'Processing quantity second',
        platformaccess: 'VoidChain platform access',
        emailsupport: 'Email support',
        Limiteddatastorage: 'Limited data storage',
        UnlimitedShardingList: 'VoidChain Unlimited Meta Space List',
        Partitionname: 'Meta space name',
        type: 'Type',
        numberofnodes: 'Nodes number',
        TCquantity: 'TC quantity',
        Totalnumberofaddresses: 'Addresses',
        Numberofactiveaddresses: 'Active addresses',
        Numberoftokens: 'Tokens number',
        time: 'Time',
      },
      tokeList: {
        Token: 'Token',
        price: 'Price',
        change: 'Change',
        Tradingvolume: 'Volume (24 hours)',
        marketequity: 'Market equity',
        Highestprice: 'Highest (24 hours)',
        Lowestprice: 'Lowest (24 hours)',
        dollar: 'Dollar',
      },
      DevelopmentDocuments: {
        Technicaldocumentation: 'Technical documentation',
        Populararticles: 'Popular articles',
        Allcategories: 'All',
        All: 'All',
        Tutorial: 'Tutorial',
        General: 'General',
        Common: 'Common',
      },
      ShardInformation: {
        issuingdate: 'Issuing date',
        Consensusalgorithm: 'Consensus algorithm',
        HighestTPS: 'Highest TPS',
        actionmessage: 'Action message',
        AddressOverview: 'Address Overview',
        NodeOverview: 'Node Overview',
        Totalnumberofblocks: 'Total number of blocks',
        Totalnumberofactivities: 'Total number of activities',
        Numberofregularactivities: 'Number of regular activities',
        Numberofcontractactivities: 'Number of contract activities',
        NumberofContentActivities: 'Number of Content Activities',
        Totalnumberofaddresses: 'Total number of addresses',
        Numberofaccounts: 'Number of accounts',
        Numberofcontractaddresses: 'Number of contract addresses',
        NumberofContentAddresses: 'Number of Content Addresses',
        Numberofnewlyaddedaccounts: 'Number of newly added accounts',
        Totalnumberofnodes: 'Total number of nodes',
        oneNum: 'One layer quantity (computational power)',
        twoNum: 'Two layer quantity (computational power)',
        threeNum: 'Three layer quantity (computational power)',
        fourNum: 'Four layer quantity (computational power)',
        Recentactivities: 'Recent activities',
        transaction: 'transaction',
        Ordinaryactivities: 'Ordinary activities',
        Transferactivity: 'Transfer activity',
        Equipmentactivities: 'Equipment activities',
        Contentactivities: 'Content activities',
        Platformactivities: 'Platform activities',
      },
      OnChainQuery: {
        Owner: 'Owner',
        control: 'Control',
        accounttype: 'Account type',
        Controlaccount: 'Control account',
        Contractaccount: 'Contract account',
        Trustmachineaccount: 'Trust machine account',
        Typeaccount: 'Type account',
        ProductAccount: 'Product Account',
        Modelaccount: 'Model account',
        FreeEnergy: 'Free Energy',
        Purchaseenergy: 'Purchase energy',
        PlatformRights: 'Platform Rights',
        Additionalinformation: 'Additional information',
        promoter: 'Promoter',
        recipient: 'Recipient',
        transactiontype: 'Transaction type',
        Ordinaryactivities: 'Ordinary activities',
        Transferactivity: 'Transfer activity',
        Equipmentactivities: 'Equipment activities',
        Contentactivities: 'Content activities',
        Platformactivities: 'Platform activities',
        Transactioncontent: 'Trading content',
        TransactionNumber: 'Trading Number',
        TradingHours: 'Trading Hours',
        TransactionStatus: 'Trading Status',
        tradingpool: 'The transaction is still in the trading pool',
        awaitingconfirmation: 'The transaction has been packaged and is awaiting confirmation',
        Successfultrade: 'Successful trade',
        Transactionfailed: 'Transaction failed to delete',
        Transactionresults: 'Trading results',
        blockheight: 'Block height',
        Generationtime: 'Generation time',
        FatherBlock: 'Father Block',
        Packager: 'Packager',
        worldstate: 'World state',
        TradingRoot: 'Trading Root',
        Receiptroot: 'Receipt root',
        TransactionList: 'Transaction List',
      },
    },
    'zh-CN': {
      nav: {
        TCPrice: 'TC价格',
        dollar: '美元',
        totop: '回到前面',
        Copyright: '版权所有',
      },
      index: {
        blockchainexplorer: 'VoidChain区块链浏览器',
        AllFilters: '所有过滤器',
        address: '地址查询',
        transaction: '交易查询',
        block: '区块查询',
        desc: 'VoidChain 信任节点区块链-主网节点在不受人类干扰的完全去中心化封闭安全空间中运行',
        Dynamicsharding: '动态元空间',
        TotalBlock: '总区块数',
        Numberofaddresses: '地址数',
        Staticsharding: '静态元空间',
        Activeaddress: '活跃地址',
        Totalnumberofnodes: '总节点数',
        Addnewnodes: '新增节点数',
        oneNum: '一层数量(绿色算力竞争)',
        twoNum: '二层数量(绿色算力竞争)',
        threeNum: '三层数量(绿色算力竞争)',
        fourNum: '四层数量(绿色算力竞争)',
        Tokentotal: '代币总数',
        Tradingvolume: '24h链上交易量',
        latestdata: '最新数据',
        consensus: '共识算法',
        Processingquantitypersecond: '每秒传输的事物处理个数',
        platformaccess: 'VoidChain平台接入',
        emailsupport: '电子邮件支持',
        Limiteddatastorage: '有限的数据存储',
        UnlimitedShardingList: 'VoidChain无限元空间列表',
        Partitionname: '元空间名称',
        type: '类型',
        numberofnodes: '算力节点数量',
        TCquantity: 'TC数量',
        Totalnumberofaddresses: '地址总数',
        Numberofactiveaddresses: '活跃地址数',
        Numberoftokens: '代币数量',
        time: '时间',
      },
      tokeList: {
        Token: '代币',
        price: '价格',
        change: '涨跌',
        Tradingvolume: '成交量 (24小时)',
        marketequity: '流通市值',
        Highestprice: '最高价格 (24小时)',
        Lowestprice: '最低价格 (24小时)',
        dollar: '美元',
      },
      DevelopmentDocuments: {
        Technicaldocumentation: '技术文档',
        Populararticles: '热门文章',
        Allcategories: '所有类别',
        All: '所有',
        Tutorial: '教程',
        General: '常规',
        Common: '常见',
      },
      ShardInformation: {
        issuingdate: '发行日期',
        Consensusalgorithm: '共识算法',
        HighestTPS: '最高TPS',
        actionmessage: '活动信息',
        AddressOverview: '地址概览',
        NodeOverview: '节点概览',
        Totalnumberofblocks: '总区块数',
        Totalnumberofactivities: '总活动数',
        Numberofregularactivities: '普通活动数',
        Numberofcontractactivities: '合约活动数',
        NumberofContentActivities: '内容活动数',
        Totalnumberofaddresses: '地址总数',
        Numberofaccounts: '账号数',
        Numberofcontractaddresses: '合约地址数',
        NumberofContentAddresses: '内容地址数',
        Numberofnewlyaddedaccounts: '新增账号数',
        Totalnumberofnodes: '总节点数',
        oneNum: '一层数量(绿色算力竞争)',
        twoNum: '二层数量(绿色算力竞争)',
        threeNum: '三层数量(绿色算力竞争)',
        fourNum: '四层数量(绿色算力竞争)',
        Recentactivities: '最近活动',
        transaction: '笔交易',
        Ordinaryactivities: '普通活动',
        Transferactivity: '转账活动',
        Equipmentactivities: '设备活动',
        Contentactivities: '内容活动',
        Platformactivities: '平台活动',
      },
      OnChainQuery: {
        Owner: '拥有者',
        control: '受案控制',
        accounttype: '账号类型',
        Controlaccount: '控制账号',
        Contractaccount: '合约账号',
        Trustmachineaccount: '信任机账号',
        Typeaccount: '类型账号',
        ProductAccount: '产品账号',
        Modelaccount: '型号账号',
        FreeEnergy: '免费能量',
        Purchaseenergy: '购买能量',
        PlatformRights: '平台权益',
        Additionalinformation: '附加信息',
        promoter: '发起人',
        recipient: '接收人',
        transactiontype: '交易类型',
        Ordinaryactivities: '普通活动',
        Transferactivity: '转账活动',
        Equipmentactivities: '设备活动',
        Contentactivities: '内容活动',
        Platformactivities: '平台活动',
        Transactioncontent: '交易内容',
        TransactionNumber: '交易序号',
        TradingHours: '交易时间',
        TransactionStatus: '交易状态',
        tradingpool: '交易仍在交易池',
        awaitingconfirmation: '交易已打包等待确认中',
        Successfultrade: '交易成功',
        Transactionfailed: '交易失败删除',
        Transactionresults: '交易结果',
        blockheight: '区块高度',
        Generationtime: '生成时间',
        FatherBlock: '父区块',
        Packager: '打包者',
        worldstate: '世界状态',
        TradingRoot: '交易根',
        Receiptroot: '收据根',
        TransactionList: '交易列表',
      },
    },
  },
})

Vue.prototype._i18n = i18n

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app')
